import { useLingui } from '@lingui/react/macro';

import {
  FilterCheckboxItem,
  FiltersList,
  FiltersSubMenu,
} from '@/design_system/Filters/FiltersDrawer/FiltersDrawer';
import IconPerson from '@/icons/User.svg';

import { CLIENT_FILTER_OPTIONS, ClientFilterId } from '../clientFilterOptions';
import { useFilters } from '../FiltersState';

export const MobileFiltersHasClient = () => {
  const { t, i18n } = useLingui();

  const {
    hasClient: { hasClient, setHasClient },
  } = useFilters();

  const toggle = (id: ClientFilterId) => {
    if (hasClient.includes(id)) {
      setHasClient(hasClient.filter((x) => x !== id));
    } else {
      setHasClient([...hasClient, id]);
    }
  };

  const options = CLIENT_FILTER_OPTIONS.map(({ id, label }) => (
    <FilterCheckboxItem key={id} id={id} label={i18n._(label)} />
  ));

  return (
    <FiltersSubMenu
      id="has-client"
      icon={<IconPerson />}
      label={t({
        id: 'settings.organization.entities.agreements.filters.client.label',
        message: 'Client',
      })}
      count={hasClient.length}
    >
      <FiltersList
        ariaLabel={t({
          id: 'settings.organization.entities.agreements.filters.client.label',
          message: 'Client',
        })}
        values={hasClient}
        onChange={toggle}
      >
        {options}
      </FiltersList>
    </FiltersSubMenu>
  );
};
